import { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Unicon from './Unicon';

const icons = {
    info: "information-circle",
    warning: "warning",
    danger: "alert-circle",
    error: "alert-circle",
    success: "checkmark-circle"
}

// Dismissed callouts stay hidden for the whole JS session (survives
// unmount/remount) and reset on reload — there is no persisted storage.
const dismissedCallouts = new Set();


export default function Callout({ title = "", message, type = "info", children = null, style = null, testID, dismissible = false, dismissKey }) {
    const colorKey = type === 'danger' ? 'error' : type;
    const [dismissed, setDismissed] = useState(() => !!dismissKey && dismissedCallouts.has(dismissKey));
    if (dismissed) return null;

    return (
        <View style={[styles.container(colorKey), style]} testID={testID}>
            <Unicon name={icons[type] || icons.info} size={14} colorVariant={colorKey} style={styles.icon} />
            <View style={styles.textContainer}>
                {!!title && <Text style={styles.title(colorKey)}>{title}</Text>}
                {!!message && <Text style={styles.message}>{message}</Text>}
                {children}
            </View>
            {dismissible && (
                <Pressable
                    onPress={() => {
                        if (dismissKey) dismissedCallouts.add(dismissKey);
                        setDismissed(true);
                    }}
                    hitSlop={8}
                    style={styles.dismissButton}
                    accessibilityRole="button"
                    accessibilityLabel="Dismiss"
                    testID={testID ? `${testID}-dismiss` : undefined}
                >
                    <Unicon name="close" size={14} colorVariant="textSecondary" />
                </Pressable>
            )}
        </View>
    )
}


const styles = StyleSheet.create(({ colors, fonts }) => ({
    container: (colorKey) => ({
        width: "100%",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 8,
        padding: 10,
        borderLeftWidth: 3,
        borderLeftColor: colors[colorKey] || colors.info,
        backgroundColor: colors.surface,
        marginBottom: 10
    }),
    icon: {
        marginTop: 1
    },
    textContainer: {
        flex: 1,
        gap: 2
    },
    title: (colorKey) => ({
        color: colors[colorKey] || colors.info,
        fontFamily: fonts.bold,
        fontSize: 12
    }),
    message: {
        fontSize: 12,
        fontFamily: fonts.body,
        color: colors.text,
        lineHeight: 17
    },
    dismissButton: {
        padding: 2,
        _web: {
            cursor: 'pointer'
        }
    }
}))
